import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
//
import { useNavigate } from "react-router";
import { useIntl } from "react-intl";
//
import Box from "@mui/material/Box";
import { styled } from "@material-ui/styles";
// component, hooks
import StyledFirebaseAuth from "react-firebaseui/StyledFirebaseAuth";
import { useSearchParams } from "react-router-dom";
import useLocaleRoute from "../../../../common/hooks/useLocaleRoute";
// store
import { StoreContext } from "../../../../store/StoreProvider";
import Act from "../../../../store/actions";
// config,utils
import { ROUTE_PATH, ROUTE_NAME } from "../../../../config/CONSTANTS";
import urls from "../../../../api/project/ApiUrls";
import fireAuth from "../../../../api/firebase/auth/utils";

// style

const FirebaseAuthLogin = () => {
  //
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const backUrl = searchParams.get("backUrl");

  // 語系
  const intl = useIntl();
  // style

  // props

  // store
  const [state, dispatch] = useContext(StoreContext);
  const { user: globalUser } = state;
  const { displayName, locale } = globalUser;
  const isLoggedIn = fireAuth.isLoggedIn(globalUser);
  // hooks
  const { handleLocaleRoute } = useLocaleRoute(
    locale,
    urls?.locale_lang?.LOCALE_DEFAULT
  );

  // local state
  const [uiConfig, setUiConfig] = useState({
    ...fireAuth.getAuthUiConfig(),
    callbacks: {
      signInSuccessWithAuthResult: (authResult, redirectUrl) => {
        console.log("redirectUrl", redirectUrl);
        const { user } = authResult;
        const { displayName: userName } = user;
        dispatch({
          type: Act.COMMON_SET_MESSAGE,
          payload: {
            open: true,
            content: intl.formatMessage(
              {
                id: "login.success.message",
                defaultMessage: "{name}, 你已成功登入",
              },
              {
                name: userName,
              }
            ),
          },
        });
        // 回到前一個頁面
        // navigate(-1);
        console.log("backUrl", backUrl);
        if (backUrl) {
          // e.g. "/zh-tw/invitation?inviteid=XhJ8ExvHgjJj8prVw4ti"
          navigate(backUrl);
          // navigate(-1);
        } else {
          navigate(handleLocaleRoute(ROUTE_PATH.Console));
        }

        return true;
      },
      signInFailure: (error) => {
        dispatch({
          type: Act.COMMON_SET_MESSAGE,
          payload: {
            open: true,
            content: error.message,
          },
        });
      },
    },
  });

  return (
    <StyledFirebaseAuth uiConfig={uiConfig} firebaseAuth={fireAuth.getAuth()} />
  );
};

FirebaseAuthLogin.propTypes = {};

FirebaseAuthLogin.defaultProps = {};

export default FirebaseAuthLogin;
